import React, { useState } from 'react';
import Card from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import Table from '../../components/ui/Table';
import Avatar from '../../components/ui/Avatar';
import Button from '../../components/ui/Button';
import { useToast } from '../../components/ui/Toast';
import { displayReports, employees, stores } from '../../data/mockData';
import { Download, Camera } from 'lucide-react';

export default function DisplayReports() {
  const toast = useToast();
  const [filter, setFilter] = useState('');

  const enriched = displayReports.map(r => ({
    ...r,
    employeeName: employees.find(e => e.id === r.employeeId)?.name || r.employeeId,
    storeName: stores.find(s => s.id === r.storeId)?.name || r.storeId,
  }));

  const filtered = filter ? enriched.filter(r => r.status === filter) : enriched;

  const columns = [
    { key: 'date', label: 'Дата', render: v => <span style={{ fontSize: 12, color: '#6B7280' }}>{new Date(v).toLocaleString('ru-RU')}</span> },
    {
      key: 'employeeName', label: 'Сотрудник',
      render: (v) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Avatar name={v} size={28} />
          <span style={{ fontWeight: 500, fontSize: 13 }}>{v}</span>
        </div>
      )
    },
    { key: 'storeName', label: 'Магазин', render: v => <span style={{ fontSize: 12, color: '#6B7280' }}>{v}</span> },
    { key: 'productName', label: 'Товар', render: v => <span style={{ fontWeight: 500, fontSize: 13 }}>{v}</span> },
    { key: 'requiredQty', label: 'Требуемое', render: v => <span style={{ color: '#6B7280' }}>{v} шт.</span> },
    {
      key: 'placedQty', label: 'Выложено',
      render: (v, row) => (
        <span style={{ fontWeight: 700, color: v >= row.requiredQty ? '#34C759' : '#FF9500' }}>
          {v} шт.
        </span>
      )
    },
    {
      key: 'hasPhoto', label: 'Фото', sortable: false,
      render: (v, row) => v ? (
        <button onClick={() => toast('Просмотр фото', 'success')} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '4px 10px', borderRadius: 6, border: '1px solid #E5E7EB', background: '#fff', cursor: 'pointer', fontSize: 11, color: '#4A6CF7', fontFamily: 'inherit' }}>
          <Camera size={12} />Фото
        </button>
      ) : <span style={{ color: '#D1D5DB', fontSize: 12 }}>Нет фото</span>
    },
    { key: 'status', label: 'Статус', render: v => <Badge variant={v === 'with_photo' ? 'success' : 'warning'}>{v === 'with_photo' ? '📷 С фото' : '📭 Без фото'}</Badge> },
    {
      key: 'actions', label: '', sortable: false,
      render: (_, row) => row.hasPhoto ? (
        <button onClick={() => toast('Запрос повторной выкладки отправлен', 'warning')} style={{ fontSize: 11, padding: '4px 10px', borderRadius: 6, border: '1px solid #FEE2E2', background: '#FFF0F0', cursor: 'pointer', color: '#FF3B30', fontFamily: 'inherit' }}>
          Отклонить
        </button>
      ) : null
    }
  ];

  const withPhoto = displayReports.filter(r => r.hasPhoto).length;
  const withoutPhoto = displayReports.filter(r => !r.hasPhoto).length;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: '#1A1A2E' }}>Журнал выкладок</h1>
          <p style={{ color: '#8E8E93', fontSize: 13, marginTop: 2 }}>Все отчёты о выкладке товаров</p>
        </div>
        <Button variant="secondary" icon={<Download size={14} />} onClick={() => toast('Экспорт', 'success')}>Экспорт</Button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 14 }}>
        {[
          { label: 'Всего выкладок', value: displayReports.length, color: '#4A6CF7', bg: '#EEF2FF' },
          { label: 'С фото-отчётом', value: withPhoto, color: '#34C759', bg: '#F0FFF4' },
          { label: 'Без фото', value: withoutPhoto, color: '#FF9500', bg: '#FFF7ED' },
        ].map(s => (
          <div key={s.label} style={{ background: s.bg, borderRadius: 12, padding: '16px 20px', textAlign: 'center' }}>
            <div style={{ fontSize: 26, fontWeight: 800, color: s.color }}>{s.value}</div>
            <div style={{ fontSize: 12, color: '#6B7280' }}>{s.label}</div>
          </div>
        ))}
      </div>

      <Card padding="0">
        <div style={{ padding: '14px 20px', borderBottom: '1px solid #F3F4F6', display: 'flex', gap: 8 }}>
          {[{ key: '', label: 'Все' }, { key: 'with_photo', label: '📷 С фото' }, { key: 'without_photo', label: '📭 Без фото' }].map(f => (
            <button key={f.key} onClick={() => setFilter(f.key)} style={{
              padding: '6px 14px', borderRadius: 8, border: '1px solid #E5E7EB',
              background: filter === f.key ? '#4A6CF7' : '#fff',
              color: filter === f.key ? '#fff' : '#6B7280',
              fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit',
            }}>{f.label}</button>
          ))}
        </div>
        <Table columns={columns} data={filtered} emptyText="Нет отчётов" />
      </Card>
    </div>
  );
}
